@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="dialogContainer">
  <h2 mat-dialog-title>Part #: {{ this.part.partNumber }}</h2>
  <mat-dialog-content>
    <table>
      <tr>
        <td class="headerCell tableCell">Description:</td>
        <td class="tableCell">{{ this.part.description }}</td>
      </tr>
      @if (this.productInformation()?.fullDescription?.length > 0) {
        <tr>
          <td class="headerCell tableCell">Further Information:</td>
          <td class="tableCell">{{ this.productInformation().fullDescription }}</td>
        </tr>
      }
      <tr>
        <td class="headerCell tableCell">Price:</td>
        <td class="tableCell">{{ this.part.price | currency:'USD' }}</td>
      </tr>
      @if (this.productInformation()?.minAmount > 1) {
        <tr>
          <td class="headerCell tableCell">Notes:</td>
          <td class="tableCell">Unit/Part may require {{ this.productInformation()?.minAmount }} Part # {{ this.part?.partNumber }}(s)</td>
        </tr>
      }
    </table>
    @if (this.part && this.part.relatedParts && this.part.relatedParts.length > 1) {
      <table>
        <thead>
          <tr>
            <td colspan="2"><h2>Related Parts</h2></td>
          </tr>
        </thead>
        @for (relatedPart of this.part.relatedParts; track relatedPart) {
          <tr>
            <td class="headerCell tableCell">This item is required.</td>
            <td class="tableCell">{{ relatedPart.partNumber }}</td>
          </tr>
        }
      </table>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button matButton="text" mat-dialog-close>Close</button>
  </mat-dialog-actions>
</div>
